import {
  Box,
  Divider,
  List,
  ThemeProvider as MuiThemeProvider,
  darkTheme as MuiDarkTheme,
} from '@locus-taxy/encore-mui';
import type { SidebarFooterProps } from '@toolpad/core/DashboardLayout';
import SidebarUserMenu from '../sidebar/SidebarUserMenu';

export default function DashboardSidebarFooter({
  mini,
}: Readonly<SidebarFooterProps>) {
  const sidebarOpen = !mini;

  return (
    <MuiThemeProvider theme={MuiDarkTheme}>
      <Box
        className="EncoreSidebarFooter-root"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          px: sidebarOpen ? 2 : 1,
          py: 2,
          mt: 'auto',
          position: 'sticky',
          bottom: 0,
          bgcolor: 'background.paper',
          zIndex: 1,
        }}
      >
        <Divider sx={{ borderColor: 'divider' }} />
        <List disablePadding>
          <SidebarUserMenu sidebarOpen={sidebarOpen} />
        </List>
      </Box>
    </MuiThemeProvider>
  );
}
